import { Badge } from "@/components/ui/badge";
import { formatArabicLongDate } from "@/lib/formatters";

interface DashboardHeroProps {
  displayName: string;
  roleName: string;
  date?: string;
}

export function DashboardHero({
  displayName,
  roleName,
  date = formatArabicLongDate(new Date()),
}: DashboardHeroProps) {
  return (
    <div className="dashboard-hero" dir="rtl">
      <div className="accent-top-bar" />
      <div className="flex flex-col gap-4 bg-linear-to-l from-primary/5 to-card px-6 py-5 sm:flex-row sm:items-end sm:justify-between">
        <div className="space-y-2 text-right">
          <div className="flex flex-wrap items-center justify-end gap-3">
            <h2 className="text-xl font-bold text-foreground md:text-2xl">
              {displayName ? `مرحباً، ${displayName}` : "مرحباً"}
            </h2>
            {roleName && (
              <Badge variant="secondary" className="text-xs">
                {roleName}
              </Badge>
            )}
          </div>
          <p className="text-sm text-muted-foreground md:text-base">
            لوحة إدارة وزارة المالية — العراق
          </p>
        </div>
        <p className="shrink-0 text-sm text-muted-foreground">{date}</p>
      </div>
    </div>
  );
}
